<div class="item-tags" *ngIf="itemIcons?.length > 0">
  <span class="tags" [theme]="options" *ngFor="let icon of itemIcons">
    <ng-container *ngIf="getImageURL(icon) as iconURL">
      <img [src]="iconURL" alt="image url"/>
      <ng-container *ngIf="showText">{{ getIconName(icon) }}</ng-container>
    </ng-container>
  </span>
</div>
